import { render, staticRenderFns } from "./CmgFullOrderDetailsModal.vue?vue&type=template&id=40c2e383&scoped=true&lang=pug"
import script from "./cmg-full-order-details-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-full-order-details-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFullOrderDetailsModal.vue?vue&type=style&index=0&id=40c2e383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2e383",
  null
  
)

export default component.exports